import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import TapSelect from '../../components/ui/TapSelect';
import InputWorkstationSearch from '../includes/ui/InputWorkstationSearch';
import InputEmployeeSearch from '../includes/ui/InputEmployeeSearch';
import AdditionalAttributeForm from '../includes/ui/AdditionalAttributeForm';
import { useSelector } from 'react-redux';

const SiteProductivityModal = forwardRef(({ configurationData, onSave }, ref) => {

    const initialModalFormData   =  {
        material_id                 :   "",
        attachment_id               :   "",
        workstation_id              :   "",
        employee_ids                :   "",
        trip                        :   "",
        production                  :   "",
    }

    const setting               =    useSelector(state => state.app.setting)

    const [prodModalFormData, setProdModalFormData] = useState(initialModalFormData);
    const [activityData, setActivityData] = useState(null);
    const [index, setIndex] = useState(null);

    const [searchedWorkstation, setSearchedWorkstation]      =   useState(null);
    const [selectedEmployee, setSelectedEmployee]            =   useState(null);
    const [isConfiguration, setIsConfiguration]              =   useState(false);


    const modalElem = useRef(null);
    const modal = useRef(null);

    useImperativeHandle(ref, () => ({
        initModalHandler: (activityIndex, productivity_data) => {
            if (productivity_data) {
                setProdModalFormData(pre => ({ ...pre, ...productivity_data }));
            }

            setIndex(activityIndex);
            const activityData = configurationData[activityIndex];

            if (activityData.additional_atts.length <= 0 && activityData.attachment == "N" && activityData.material == "N" && activityData.attachment == "N" && activityData.workstation == "N" && activityData.number_of_trip == "N" && activityData.employee == "N") {
                setIsConfiguration(true)
            }
            if (activityData) {
                setActivityData(activityData);
                modalOpen();
            }
        }
    }));

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose = () => {
        // setSearchedWorkstation(null);
        // setSelectedEmployee([]);
        setProdModalFormData(initialModalFormData);
        if (modal.current) { modal.current.hide(); }
        setIsConfiguration(false)
    };

    useEffect(() => {
        modalElem.current = document.getElementById('siteProductivityModal');
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);

    const handleInputChange = (e) => {
        setProdModalFormData({
            ...prodModalFormData,
            [e.target.name]: e.target.value
        });
    };

    const handleSelectChange = (name, value) => {
        setProdModalFormData({
            ...prodModalFormData,
            [name]: value
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setIsConfiguration(false)

        let additional_attributes = {};
        if (activityData.hasOwnProperty('additional_atts') && activityData.additional_atts.length > 0) {
            activityData.additional_atts.forEach((i, k) => {
                let name = 'additional_attributes_' + i.key;
                additional_attributes[i.key] = prodModalFormData[name] ? prodModalFormData[name] : '';
            });
        }

        let newData = { ...prodModalFormData, additional_attributes };
        onSave(index, newData);
        modalClose();
    };

    return (
        <div className="modal fade" id="siteProductivityModal" tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Activity: {activityData?.activity?.activity_name}</h5>
                        <button type="button" className="btn-close" onClick={modalClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            {isConfiguration
                                ?
                                <p className='text-center'> This Activity has no Configuration</p>
                                :
                                <>
                                    {activityData?.material === 'Y' && (
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label className={`form-label ${activityData.material_required === 'Y' ? 'require' : ''}`}>Material</label>
                                            </div>
                                            <div className="col-sm-7">
                                                <TapSelect
                                                    options={activityData.materials.map(mt => ({ value: mt.id, label: mt.material_name }))}
                                                    changeEvent={(selectedOption) => handleSelectChange('material_id', selectedOption.value)}
                                                    isSearchable={true}
                                                    value={activityData.materials.find(mt => mt.id === prodModalFormData.material_id) ? {
                                                        value: prodModalFormData.material_id,
                                                        label: activityData.materials.find(mt => mt.id === prodModalFormData.material_id)?.material_name
                                                    } : null}
                                                    isClearable={true}
                                                    placeholder="Select Material"
                                                    autoComplete="off"
                                                    required={activityData.material_required === 'Y'}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {activityData?.number_of_trip === 'Y' && (
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label className={`form-label ${activityData.number_of_trip_required === 'Y' ? 'require' : ''}`}>Number of Trips/Sessions</label>
                                            </div>
                                            <div className="col-sm-7">
                                                <input
                                                    name="trip"
                                                    type="text"
                                                    value={prodModalFormData.trip}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder="Number of Trips/Sessions"
                                                    required={activityData.number_of_trip_required === 'Y'}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {activityData?.attachment === 'Y' && (
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label className={`form-label ${activityData.attachment_required === 'Y' ? 'require' : ''}`}>{setting?.attachment_name ? setting?.attachment_name : 'Attachment'}</label>
                                            </div>
                                            <div className="col-sm-7">
                                                <TapSelect
                                                    options={activityData.attachments.map(att => ({ value: att.id, label: att.name }))}
                                                    changeEvent={(selectedOption) => handleSelectChange('attachment_id', selectedOption.value)}
                                                    isSearchable={true}
                                                    value={activityData.attachments.find(att => att.id === prodModalFormData.attachment_id) ? {
                                                        value: prodModalFormData.attachment_id,
                                                        label: activityData.attachments.find(att => att.id === prodModalFormData.attachment_id)?.name
                                                    } : null}
                                                    isClearable={true}
                                                    placeholder={`Select ${setting?.attachment_name ? setting?.attachment_name : 'Attachment'}`}
                                                    autoComplete="off"
                                                    required={activityData.attachment_required === 'Y'}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {activityData?.workstation === 'Y' && (
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label className={`form-label ${activityData.workstation_required === 'Y' ? 'require' : ''}`}>WorkStation</label>
                                            </div>
                                            <div className="col-sm-7">
                                                <InputWorkstationSearch
                                                    placeholder="Please Select Workstation"
                                                    changeEvent={(selectedOption) => {
                                                        setSearchedWorkstation(pre => ({ ...pre, [index]: selectedOption }));
                                                        handleSelectChange('workstation_id', selectedOption.value);
                                                    }}
                                                    menuPlacement="top"
                                                    search_site_id={prodModalFormData.site_id}
                                                    // required={activityData.workstation_required === 'Y'}
                                                    value={searchedWorkstation ? searchedWorkstation[index] : null}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {activityData?.employee === 'Y' && (
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label htmlFor="employee_ids" className={['form-label', activityData.employee_required === 'Y' ? 'require' : ''].join(' ')}>
                                                    Employee
                                                </label>
                                            </div>
                                            <div className="col-sm-7">
                                                <InputEmployeeSearch
                                                    placeholder="Please Select Employee"
                                                    search_site_ids={prodModalFormData.site_id}
                                                    changeEvent={(selectedOption) => {
                                                        const employeeIds = selectedOption ? selectedOption.map(opt => opt.value) : [];
                                                        handleSelectChange('employee_ids', employeeIds)
                                                        setSelectedEmployee(pre => ({ ...pre, [index]: selectedOption || [] }));
                                                    }}
                                                    isMulti={true}
                                                    required={activityData.employee_required === 'Y'}
                                                    value={selectedEmployee ? selectedEmployee[index] : []}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {activityData?.additional_atts && activityData.additional_atts.length > 0 &&
                                        <AdditionalAttributeForm
                                            additionalAttributes={activityData.additional_atts}
                                            formState={prodModalFormData}
                                            onAttributeChange={(value, attributeName) => {
                                                setProdModalFormData(pre => ({
                                                    ...pre,
                                                    [attributeName]: value
                                                }))
                                            }
                                            }
                                            colSpan={"col-sm-7"}
                                        />}
                                </>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={modalClose}>Close</button>
                            {!isConfiguration ? <button type="submit" className="btn btn-primary">Save</button> :" "}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});

export default SiteProductivityModal;